import { styled } from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  align-items: center;
`;

const NFTContainer = styled.div`
  position: relative;
  width: 8.25rem;
  height: 8.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.75rem;
  border: 1px dashed #beb3a9;
  overflow: hidden;
`;

const Text = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  p {
    text-align: center;
    font-style: normal;
    line-height: normal;
    &:first-child {
      color: ${({ theme }) => theme.colors.black};
      font-size: 1rem;
      font-weight: 700;
    }
    &:last-child {
      color: ${({ theme }) => theme.colors.secondaryText};
      font-size: 0.75rem;
      font-weight: 600;
    }
  }
`;

export default {
  Container,
  NFTContainer,
  Text,
};
